export enum AuthorizationStatus {
	Undefined,
	Succesful,
	Error,
	Connecting,
}
